import { auth } from '../auth/firebase'
import { env } from '../config/env'

export class ApiError extends Error {
  constructor(
    public status: number,
    public path: string,
    public body: unknown,
  ) {
    super(`${status} ${path}`)
  }
}

export async function fetchJson<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const url = (env.apiBaseUrl || '') + path
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  const token = await auth.currentUser?.getIdToken()
  if (token) headers.set('Authorization', `Bearer ${token}`)

  const res = await fetch(url, { ...init, headers })
  let body: unknown = null
  const ct = res.headers.get('content-type') ?? ''
  if (ct.includes('application/json')) {
    body = await res.json().catch(() => null)
  } else {
    body = await res.text().catch(() => null)
  }

  if (!res.ok) throw new ApiError(res.status, path, body)
  return body as T
}

// Many endpoints respond as { success: true, data: T } via response.ts;
// some legacy/list endpoints return T directly. Accept either shape.
export function unwrap<T>(body: unknown): T {
  if (body && typeof body === 'object' && 'data' in body) {
    return (body as { data: T }).data
  }
  return body as T
}

export async function fetchData<T = unknown>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  return unwrap<T>(await fetchJson(path, init))
}
